// extracted by mini-css-extract-plugin
module.exports = {"container":"UserTracking_container__3eFoj","text":"UserTracking_text__ijdyh"};